import { render } from "./caseDetails.vue?vue&type=template&id=ea9e6b90&scoped=true"
import script from "./caseDetails.vue?vue&type=script&lang=js"
export * from "./caseDetails.vue?vue&type=script&lang=js"

import "./caseDetails.vue?vue&type=style&index=0&id=ea9e6b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9e6b90"]])

export default __exports__